<template>
  <div class="loader loader-default is-active" :data-text="text" data-blink v-show="show">
  </div>
</template>

<script>
import "pure-css-loader/dist/css-loader.css";

export default {
  name: "Loading",
  props: {
    show: {
      required: true,
      type: Boolean
    },
    text: {
      type: String
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Loading.vue